import { FormikHelpers } from "formik";
import OteConTypeForm from "./OteConTypeForm";
import { useGetOteConType } from "./api/getOteConType";
import { useEditOteConType } from "./api/editOteConType";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditOteConType = ({handleCloseModal, oteConTypeId}: EditOteConTypeProps)  => {
  const getOteConTypeQuery = useGetOteConType({oteConTypeId: oteConTypeId})
  const editOteConTypeMutation = useEditOteConType({data: {}, oteConTypeId});

  const handleSubmit = async (values: IPostEditOteConType, { setSubmitting }: FormikHelpers<IPostEditOteConType>): Promise<void> => {
    try {
      await editOteConTypeMutation.mutateAsync({
        data: values,
        oteConTypeId: oteConTypeId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    }finally{
      setSubmitting(false);
    }
  }

  if (getOteConTypeQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getOteConTypeQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους γραμμής ΟΤΕ.</div>
    )
  }

  return (
    <>
      {!getOteConTypeQuery.isLoading && getOteConTypeQuery.data &&
        <OteConTypeForm initialValues={getOteConTypeQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditOteConTypeProps {
  oteConTypeId: number;
  handleCloseModal: () => void;
}

export default EditOteConType;